<template>
<div id="politicas" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>

        <v-layout align-center justify-center>
            <v-flex xs12 s12 m12 l12>
                <base-material-card color="primary" icon="library_books" title="Política de Privacidad y Aviso de Confidencialidad" class="elevation-1 px-5 py-3" >
                    <v-card-text>
                        <v-card-title>
                            <span class="headline" ></span>
                        </v-card-title>
                        <v-form ref="form" lazy-validation>
                            <v-container grid-list-md text-xs-center >
                                <v-card>
                                    <v-container grid-list-md text-xs-center>
                                        <v-layout row wrap>
                                            <v-flex s12 m12 l12>
                                                <span style="color:indigo;font-weight:bolder;" >Política de Privacidad</span>
                                                <br/><span style="color:info;font-weight:bold;" >Link de consulta: <v-btn small text color="info" to="/politica_privacidad" >Política de Privacidad</v-btn></span>
                                                <ckeditor class="document-editor" :editor="editor" @ready="onReady" v-model="model.politica_privacidad" :rules="[rules.required]" :config="editorConfig" ></ckeditor>
                                            </v-flex>
                                        </v-layout>
                                        <br/>
                                        <hr>
                                        <v-layout row wrap>
                                            <v-flex s12 m12 l12>
                                                <span style="color:indigo;font-weight:bolder;" >Aviso de Confidencialidad </span> <span style="color:indigo;" >(Se enviará en el correo de bienvenida al usuario)</span>
                                                <br/>
                                                <ckeditor class="document-editor" :editor="editor" @ready="onReady" v-model="model.aviso_confidencialidad" :rules="[rules.required]" :config="editorConfig" ></ckeditor>
                                            </v-flex>
                                        </v-layout>                                        
                                    </v-container>
                                </v-card>                                
                               
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="guardar" :loading="loading" >{{ model.id_politicas ? "Actualizar" : "Guardar" }}
                        </v-btn>
                    </v-card-actions>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";

export default {
    components: {},
    data: () => ({
        fab: false,
        editor: DecoupledEditor,
        editorConfig: {
            toolbar: [
                "heading",
                "|",
                "fontSize",
                "FontFamily",
                "|", ,
                "bold",
                "italic",
                "underline",
                "Highlight",
                "|",
                "alignment",
                "NumberedList",
                "BulletedList",
                "|",
                "link",
                "blockQuote",
                "|",
                "undo",
                "redo"
            ]
        },
        breadcrumbs: [{
                text: "Administración",
                disabled: false,
                to: "/admin"
            },
            {
                text: "Política de Privacidad y Aviso de Confidencialidad",
                disabled: true,
                to: ""
            }
        ],
                
        loading: false,
        update: false,
        model: {
            id_politicas: 0,
            politica_privacidad:"",
            aviso_confidencialidad:"",
            usuario_updated:"",
        },
        rules: {
            required: v => !!v || "Este campo es requerido",            
        },
        URL: ""
    }),

    methods: {
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.view.editable.element.parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.view.editable.element
            );
        },
        guardar() {
            const datos = this.model;

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var metodo = "post";
                var urlCliente = this.URL;
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id_politicas + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });                        
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos"
                            //showConfirmButton: false,
                        });                        
                    }).then(() => {    
                        this.cargarPoliticas();                        
                    });
            }
        },

        cargarPoliticas: function() {
            axios
                .get(this.URL + "get_politicas/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        if (res.data.id_politicas != undefined && res.data.id_politicas > 0) {
                                this.model = res.data;   
                                this.model.usuario_updated = this.$local_storage.get("email");
                                this.update = true; //Significa, que ya tiene datos y hay que actualizarlos                                                                                  
                        } else {
                            this.model.politica_privacidad = "Ingrese aquí la política de privacidad";
                            this.model.aviso_confidencialidad = "Ingrese aquí el aviso de confidencialidad";
                            this.model.usuario_updated = this.$local_storage.get("email");
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener las políticas del sistema.",
                        footer: ""
                    });
                    console.log(err);                                        
                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });
        },
                            
    }, //methods
    created: function () {
        this.URL = this.$hostname + "configuracion/politicas/";             
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.cargarPoliticas();        
    }
};
</script>

<style>
.document-editor {
    border: 1px solid !important;

    /* Set vertical boundaries for the document editor. */
    min-height: 250px;
    max-height: 450px;

    /* This element is a flex container for easier rendering. */
    display: flex;
    flex-flow: column nowrap;
}
</style>
